// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Hzq8","inner":"Footer_inner__3YH__"};